export default __webpack_public_path__ + "static/media/Professional-Reference-Guidelines.f9cf6e32.pdf";